<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <div class="">
        <b-row no-gutters class="head-total p-3 h-auto">
          <b-col>
            <div class="bg-secondary">
              <p>Total Amount</p>
              <p>(ราคารวม)</p>
              <p class="points">
                {{ transaction.price_with_no_discount | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>GP Discount</p>
              <p>(ส่วนลด GP)</p>
              <p class="points">
                {{ transaction.discount | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>Total Amount Exclude VAT</p>
              <p>(มูลค่าไม่รวม VAT)</p>
              <p class="points">
                {{ (transaction.price - transaction.vat) | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>Vat</p>
              <p>(ภาษีมูลค่าเพิ่ม)</p>
              <p class="points">
                {{ transaction.vat | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>Total Net Amount</p>
              <p>(ราคาสุทธิ)</p>
              <p class="points">
                {{ transaction.price | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row class="px-3 py-1 align-items-center">
        <b-col cols="3" class="pr-0">
          <InputText
            v-model="filter.search"
            textFloat="EAN/Article"
            placeholder="EAN/Article"
            type="text"
            @onEnter="searchProduct"
          >
            <template v-slot:text>
              <u
                @click="searchProduct"
                class="text-desc-message text-black font-weight-bold pointer"
                >ค้นหา</u
              >
            </template>
          </InputText>
        </b-col>
        <b-col cols="3" class="pr-0">
          <div class="d-flex align-items-center mt-3">
            <div class="text-link-custom" @click="selectBarcode()">
              Select GP Barcode
            </div>
            <div class="ml-2" v-if="form.gp_rate">
              {{ form.gp_barcode }} : {{ form.gp_rate }} %
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="m-3">
        <b-row class="mx-0 text-center header-products">
          <b-col cols="1" class="header-products-item">
            <p>จำนวน</p>
            <p>Qty</p>
          </b-col>
          <b-col md="4" class="header-products-item">
            <p>รายละเอียดสินค้า/โปรโมชั่น</p>
            <p>Description/Promotion</p>
          </b-col>
          <b-col class="header-products-item">
            <p>ราคาต่อหน่วย</p>
            <p>Unit Price</p>
          </b-col>
          <b-col class="header-products-item">
            <p>ราคารวม</p>
            <p>Total</p>
          </b-col>
          <b-col class="header-products-item">
            <p>ส่วนลด</p>
            <p>Discount</p>
          </b-col>
          <b-col cols="3" xl="2" class="header-products-item">
            <p>ราคาสุทธิ</p>
            <p>Net</p>
          </b-col>
        </b-row>
      </div>
      <div class="product-list-container px-3">
        <div class="item-products" v-if="form.products.length > 0">
          <b-row
            v-for="(product, index) in form.products"
            :key="index"
            @click="setSelectProduct({ index: index, ...product })"
            :class="[
              'product-panel align-items-center mx-0 mb-2 py-1',
              { selected: productSelected.index == index },
            ]"
          >
            <b-col cols="1" class="text-center border-product py-2">
              <p @click="downProductQuantity(index)">
                <font-awesome-icon
                  icon="minus-circle"
                  title="down-btn"
                  class="pointer"
                />
              </p>
              <p
                v-if="!clickQuantity || product.serial"
                @click="changeQuantity(product.is_serial)"
                class="my-0"
              >
                {{ product.quantity }}
              </p>
              <InputText
                v-else-if="clickQuantity && !product.serial"
                v-model="product.quantity"
                @blur="handleKeyQuantity(index, product.quantity)"
                @onEnter="handleKeyQuantity(index, product.quantity)"
                class="my-1 text-quantity d-flex justify-content-center"
              ></InputText>

              <p @click="upProductQuantity(index)">
                <font-awesome-icon
                  icon="plus-circle"
                  title="up-btn"
                  class="pointer"
                  :class="{ 'text-gray': product.is_serial }"
                />
              </p>
            </b-col>
            <b-col md="4" class="pointer">
              <p>{{ product.barcode }}</p>
              <p class="product-info">{{ product.name }}</p>

              <p
                v-if="!product.serial && product.is_serial"
                class="product-info"
              >
                Serial Number :
                <span class="text-link" @click="selectSerial(product, index)"
                  >กรุณาระบุ Serial Number</span
                >
              </p>
              <p
                v-else-if="product.serial && product.is_serial"
                class="product-info"
              >
                Serial Number : {{ product.serial }}
                <span class="text-link" @click="selectSerial(product, index)"
                  >แก้ไข</span
                >
              </p>

              <p
                class="product-info"
                v-if="product.promotion_detail.article_type == 'ZGOLD'"
              >
                น้ำหนัก :
                <span>{{ product.total_weight | numeral("0,0.00") }} </span>
              </p>
              <p v-if="product.promotion_detail" class="product-info">
                {{ product.promotion_detail.textPromotion }}
              </p>
            </b-col>
            <b-col class="price">
              <div
                v-if="
                  product.promotion_detail &&
                  product.promotion_detail.normal_unit_price !=
                    product.promotion_detail.promo_unit_price
                "
              >
                <p>
                  {{
                    product.promotion_detail.net_price_per_item
                      | numeral("0,0.00")
                  }}
                </p>
                <p class="normal-unit-price">
                  {{ product.price | numeral("0,0.00") }}
                </p>
              </div>
              <p>{{ product.price | numeral("0,0.00") }}</p>
            </b-col>
            <b-col class="price">
              <p v-if="product.serial">
                {{ product.price | numeral("0,0.00") }}
              </p>
              <p v-else-if="product.promotion_detail">
                {{
                  (product.promotion_detail.promo_unit_price *
                    product.promotion_detail.q)
                    | numeral("0,0.00")
                }}
              </p>
            </b-col>
            <b-col class="price">
              <p v-if="product.promotion_detail">
                {{ product.promotion_detail.discount | numeral("0,0.00") }}
              </p>
            </b-col>
            <b-col cols="3" xl="2" class="price">
              <p v-if="product.promotion_detail" class="fs-16">
                {{ product.promotion_detail.net_price | numeral("0,0.00") }}
              </p>
              <div
                v-if="product.promotion_detail.article_type == 'ZGOLD'"
                class="d-flex justify-content-center mt-2"
              >
                <div class="">
                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                      >มูลค่าทอง
                      <font-awesome-icon
                        :id="`tooltip-gold-variable-${index}`"
                        icon="exclamation-circle"
                        class="pointer icon-exclamation"
                      />
                      <b-tooltip
                        :target="`tooltip-gold-variable-${index}`"
                        placement="left"
                      >
                        ราคาทองประจำวัน ต่อกรัม
                        {{ product.promotion_detail.gold_price_per_gram }}
                        *
                        {{ product.weight | numeral("0,0.00") }}
                      </b-tooltip>
                    </b-col>

                    <b-col class="text-left">
                      {{
                        product.promotion_detail.gold_value | numeral("0,0.00")
                      }}
                    </b-col>
                  </b-row>

                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                      >ค่าแรงรวม VAT
                      <font-awesome-icon
                        :id="`vat-tooltip-${index}`"
                        icon="exclamation-circle"
                        class="pointer icon-exclamation"
                      />
                      <b-tooltip
                        :target="`vat-tooltip-${index}`"
                        placement="left"
                      >
                        ค่าแรงรวม = ราคาขายสินค้า - มูลค่าทอง
                      </b-tooltip>
                    </b-col>

                    <b-col class="text-left">
                      {{
                        product.promotion_detail.cost_vat | numeral("0,0.00")
                      }}
                    </b-col>
                  </b-row>

                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                      >ค่าแรงไม่รวม
                    </b-col>

                    <b-col class="text-left">
                      {{ product.promotion_detail.cost | numeral("0,0.00") }}
                    </b-col>
                  </b-row>

                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                      >VAT
                    </b-col>

                    <b-col class="text-left">
                      {{ product.promotion_detail.vat | numeral("0,0.00") }}
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div v-else class="d-flex justify-content-center mt-2">
                <div class="">
                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                      >มูลค่าไม่รวม VAT
                    </b-col>

                    <b-col class="text-left">
                      {{
                        (product.promotion_detail.net_price -
                          product.promotion_detail.vat)
                          | numeral("0,0.00")
                      }}
                    </b-col>
                  </b-row>

                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                      >VAT
                    </b-col>

                    <b-col class="text-left">
                      {{ product.promotion_detail.vat | numeral("0,0.00") }}
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="!form.products.length" class="p-2 wrap-no-product">
          <div class="no-product">
            ไม่มีสินค้าในตะกร้า<br />
            กรุณาสแกนบาร์โค้ดหรือค้นหาสินค้า
          </div>
        </div>
        <div class="text-right w-100">
          <b-button
            variant="primary-color"
            class="btn-main-custom mr-1 my-2 px-4"
            :disabled="form.products.length == 0"
            @click="showModalSelectStock()"
          >
            <div class="d-flex align-items-center">ตั้งยอด</div>
          </b-button>
        </div>
      </div>
    </div>
    <ModalProductList
      ref="modalProductList"
      @setSelectProduct="addProduct"
      isRepair
    />
    <ModalSelectBarcode
      ref="modalBarcodeList"
      @selectBarcode="handleSelectBarcode"
      @unselectItem="handleSelectBarcode"
      :branchId="branchId"
      :productList="form.products"
    />
    <ModalSelectSerial
      ref="modalSerialList"
      @selectSerial="handleSelectSerial"
      @unselectItem="handleSelectSerial"
      :branchId="branchId"
      :productList="form.products"
    />
    <b-modal
      v-model="showModalStock"
      ref="modal"
      centered
      size="md"
      class="alert-modal"
      hide-header-close
      title="เลือกคลัง"
      footer-class="pt-0 border-0"
    >
      <div class="d-flex w-100 align-items-center justify-content-center px-3">
        <label class="mr-2 mb-2">Transfer To :</label>
        <InputSelect
          v-model="selectedStock"
          textFloat="เลือกสาขา"
          placeholder="เลือกสาขา"
          :options="stockList"
          class="flex-grow-1"
          valueField="id"
          :v="$v.selectedStock"
          :isValidate="$v.selectedStock.$error"
          textField="name"
          @onDataChange="(val) => (selectedStock = val)"
        >
          <template v-slot:option-first>
            <b-form-select-option value="" disabled
              >-- เลือกคลัง --</b-form-select-option
            >
          </template>
        </InputSelect>
      </div>

      <template #modal-footer="{ hide }">
        <div class="d-flex justify-content-between w-100 my-0">
          <b-button
            variant="close"
            class="btn-modal btn-hover w-50 mr-1"
            @click="hide('forget')"
            :disabled="isLoading"
          >
            ยกเลิก
          </b-button>
          <b-button
            variant="primary-color"
            class="btn-modal btn-hover w-50 ml-1"
            @click="saveForm"
            :disabled="isLoading"
          >
            บันทึก
          </b-button>
        </div>
      </template></b-modal
    >
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import { mapGetters } from "vuex";
import ModalProductList from "../home/components/ModalProductList.vue";
import ModalSelectBarcode from "../home/components/ModalSelectBarcode.vue";
import ModalSelectSerial from "../home/components/ModalSelectSerial.vue";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    OtherLoading,
    ModalProductList,
    ModalSelectBarcode,
    ModalSelectSerial,
  },
  data() {
    return {
      form: {
        product_group_barcode_detail_id: 0,
        total_amount: 0,
        gp_discount: 0,
        vat: 0,
        net_amount: 0,
        branch_id: 0,
        user_transaction_status_id: 1,
        products: [],
        gp_barcode: "",
        gp_rate: "",
      },
      productSelected: {
        id: 0,
        quantity: 0,
        custom_price: null,
        group_barcode: "",
        sap_discount: [],
        item_discount: [],
        index: 0,
      },
      transaction: {
        total_price: 0,
        vat: 0,
        price: 0,
        total_vat: 0,
        total_cost: 0,
        total_cost_vat: 0,
        total_gold_value: 0,
        discount: 0,
        price_with_no_discount: 0,
        product_detail: [],
        quantity: 0,
      },
      isLoading: false,
      filter: {
        search: "",
      },
      gpBarcode: "",
      clickQuantity: false,
      stockList: [],
      selectedStock: "",
      showModalStock: false,
    };
  },
  computed: {
    ...mapGetters({
      dateTimeFix: "getDateTimeFix",
      branchId: "getBranchId",
      userGuid: "getUserGuid",
    }),
  },
  validations() {
    return {
      selectedStock: { required },
    };
  },
  async created() {
    await this.getStockList();
  },
  methods: {
    async searchProduct() {
      if (!this.form.gp_rate) {
        this.warningAlert("กรุณาเลือก GP Barcode");
        return;
      }
      let user = {
        user_guid: this.userGuid,
        branch_id: this.branchId,
      };
      this.$refs.modalProductList.show(user, this.filter.search);
    },
    async addProduct(product, key) {
      this.form.products.push({
        ...product,
        quantity: 1,
        inventory_product_serial_id: null,
      });
      await this.calculateTransaction();
    },
    async calculateTransaction(value = this.user_get_point) {
      this.user_get_point = value;
      await this.$store.dispatch("setMainLoading", true);
      let product = this.form.products.map((prod, index) => {
        return {
          product_group_barcode_id: prod.product_group_barcode_id || 0,
          product_group_barcode: prod.product_group_barcode || 0,
          gp_product_barcode: prod.gp_product_barcode || 0,
          id: prod.product_id,
          q: prod.quantity,
          custom_price: prod.custom_price || null,
          group_barcode: "",
          price: prod.price,
          sap_discount: prod.sap_discount || [],
          item_discount: prod.item_discount || [],
          serial: prod.serial || "",
        };
      });

      let body = {
        price: [],
        product: product,
        customer_id: this.userGuid,
        debug: 0,
        branch_id: this.branchId,
        t_datetime: this.dateTimeFix
          ? this.$moment(this.dateTimeFix).format("YYYY-MM-DD HH:mm:ss")
          : this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        invoice_consignment_gp_barcode: this.form.gp_rate,
      };
      await this.axios
        .post(
          `${this.$baseUrl}/InvoiceConsignment/calculate_transaction_data`,
          body
        )
        .then(async (data) => {
          if (data.result) {
            await this.form.products.forEach(async (product, i) => {
              let currentProductInfo = data.detail.product_detail[i];
              this.form.products[i].promotion_detail = currentProductInfo;
              this.form.products[i].weight = currentProductInfo.weight;
              product.quantity = currentProductInfo.q;
              product.price = currentProductInfo.price;
              product.after_discount_price = currentProductInfo.net_price;
              product.gold_ratio_excluding_vat =
                currentProductInfo.gold_ratio_excluding_vat;
              product.gold_price_per_gram =
                currentProductInfo.gold_price_per_gram;
              product.gold_minimum_goldsmith_charge =
                currentProductInfo.gold_minimum_goldsmith_charge;
              product.gold_vat_variable_value =
                currentProductInfo.gold_vat_variable_value;
              product.gold_type = currentProductInfo.gold_type;
            });
            if (data.detail.price) {
              this.transaction = {
                ...data.detail.price,
                quantity: data.detail.quantity,
                product_detail: data.detail.product_detail,
              };
            } else {
              this.transaction = {
                price: 0,
                netPrice: 0,
                discount: 0,
                quantity: 0,
                point: 0,
                raw_point: 0,
                is_use_point: 0,
              };
            }
          }
        });
      await this.$store.dispatch("setMainLoading", false);
    },
    async selectBarcode(product, index) {
      this.$refs.modalBarcodeList.show(0, index);
    },
    async handleSelectBarcode(barcode_group) {
      this.form.gp_rate = barcode_group.gp_rate;
      this.form.gp_barcode = barcode_group.gp_barcode;
      this.form.product_group_barcode_detail_id = barcode_group.id;
      await this.calculateTransaction();
      this.$refs.modalBarcodeList.hide();
    },
    async setSelectProduct(product) {
      this.productSelected = product;
    },
    async handleKeyQuantity(index, value) {
      if (isNaN(value)) return;
      const quantity = parseInt(value, 10);

      this.form.products[index].quantity = quantity;
      if (value < 1) {
        this.form.products.splice(index, 1);
      }
      this.clickQuantity = false;
      this.calculateTransaction();
    },
    async upProductQuantity(index) {
      if (!this.form.products[index].is_serial) {
        this.form.products[index].quantity += 1;

        this.calculateTransaction();
      }
    },
    async downProductQuantity(index) {
      if (this.form.products[index].quantity > 1) {
        this.form.products[index].quantity -= 1;
      } else {
        this.form.products.splice(index, 1);
      }
      if (this.form.products.length == 0) {
        this.productSelected = {
          id: 0,
          quantity: 0,
          group_barcode: "",
          sap_discount: [],
          item_discount: [],
          serial: null,
          custom_price: null,
          index: 0,
        };
      }
      this.calculateTransaction();
    },
    changeQuantity(serial) {
      if (!serial) {
        this.clickQuantity = true;
      }
    },
    async selectSerial(product, index) {
      this.$refs.modalSerialList.show(product, index);
    },
    handleSelectSerial(serial, productId, index) {
      let product = this.form.products[index];

      if (serial) {
        product.serial = serial.serial;
        product.inventory_product_serial_id = serial.id;
        product.quantity = 1;
        product.custom_price = serial.price || null;
        product.total_weight = serial.weight;
        product.price = serial.price;
        this.clickQuantity = false;
      } else {
        product.serial = null;
        product.price = 0;
        product.custom_price = null;
        product.inventory_product_serial_id = null;
      }
      this.calculateTransaction();
      this.$refs.modalSerialList.hide();
    },
    getStockList() {
      this.axios
        .get(`${this.$baseUrl}/InvoiceConsignment/GetStockList`)
        .then((data) => {
          if (data.result == 1) {
            this.stockList = data.detail;
          } else {
            this.warningAlert(data.message);
          }
        });
    },
    hide() {
      this.showModalStock = false;
      this.selectedStock = "";
    },
    async showModalSelectStock() {
      let isValidSerial = this.form.products.some(
        (el) => el.is_serial == 1 && !el.inventory_product_serial_id
      );
      if (isValidSerial) {
        this.warningAlert("กรุณาระบุ Product Serial ให้ครบถ้วน");
        return;
      }
      this.showModalStock = true;
      this.selectedStock = "";
      let res = await this.axios(
        `${this.$baseUrl}/InvoiceConsignment/DefaultTaxStock/${this.branchId}`
      );
      if (res.result) {
        this.selectedStock = res.detail.defaultTaxStock || "";
      }
    },
    async saveForm() {
      this.$v.selectedStock.$touch();
      if (this.$v.selectedStock.$error) {
        return;
      }
      let stock = {
        stock_type_id: this.selectedStock,
        products: [
          ...this.form.products.map((product) => {
            return {
              product_id: product.product_id,
              quantity: product.quantity,
              inventory_product_serial_id:
                product.inventory_product_serial_id || null,
              stock_type_id: this.selectedStock,
            };
          }),
        ],
      };

      const res = await this.axios.post(
        `${this.$baseUrl}/InvoiceConsignment/TransferInvoiceConsignmentStock`,
        stock
      );

      await this.sendForm();
    },
    async sendForm() {
      this.form.branch_id = this.branchId;
      this.form.total_amount = this.transaction.price_with_no_discount;
      this.form.gp_discount = this.transaction.discount;
      this.form.vat = this.transaction.vat;
      this.form.net_amount = this.transaction.price;

      await this.axios
        .post(`${this.$baseUrl}/InvoiceConsignment/Create`, {
          ...this.form,
          stock_type_id: this.selectedStock,
        })
        .then((data) => {
          if (data.result == 1) {
            this.successAlert();
            this.$router.push("/invoice-consignment/");
          } else {
            console.log("error");
            this.warningAlert(data.message);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.head-total {
  p {
    text-align: center;
    color: var(--primary-color) !important;
    font-size: 14px;
    font-weight: 600;
  }

  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .col-sm-6 {
    min-width: 133px;
    flex: 1;
    max-width: 100%;
  }
}

.head-total {
  .col:first-of-type {
    padding-left: 0;
  }

  .col:last-of-type {
    padding-right: 0;
  }

  .bg-secondary {
    height: 100%;
    padding: 15px 0 10px 0;
    background: var(--secondary-color) !important;
  }
}

.text-link-custom {
  color: var(--primary-color) !important;
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
}

.item-products {
  color: #707070;
  font-size: 16px;
  border-radius: 8px;

  svg {
    color: #000;
  }

  .price {
    font-size: 14px;
    text-align: center;
  }

  .product-info {
    font-size: 12px;
  }

  .normal-unit-price {
    text-decoration: line-through;
  }
}

.product-panel {
  background-color: rgb(244, 244, 244) !important;

  &.selected {
    background-color: #bababa2e !important;
  }
}

.delete-credit {
  background-color: #000 !important;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 4px;
  text-align: center;

  svg {
    color: white;
    font-size: 16px;
  }
}

.product-info {
  font-size: 12px;
}

.header-products {
  font-size: 14px;
  font-weight: bold;
  gap: 4px;

  .header-products-item {
    padding: 0px;
  }
}

.product-list-container {
  overflow: auto;
  height: calc(100% - 46px - 89px - 87px - 40px);
  position: relative;

  .wrap-no-product {
    width: 100%;
    height: 100%;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;

    .no-product {
      text-align: center;
      font-size: 20px;
      padding: 15px;
      background-color: #f7f7f7;
      border-radius: 5px;
      color: #dcdcdc;
      width: 450px;
    }
  }
}

label {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
}
</style>
